import angular from 'angular';

export default function nlToBr(escapeHtml) {
  return (untrustedText) => {
    if (!untrustedText || !angular.isString(untrustedText)) {
      return untrustedText;
    }

    return untrustedText.split('\n').map(escapeHtml).join('<br>');
  };
}

nlToBr.$inject = ['escapeHtml'];